// Use VUE_APP_ENDPOINTS for endpoint selection (set by serve:prod script)
// Falls back to NODE_ENV for backwards compatibility
const useDevEndpoints = process.env.VUE_APP_ENDPOINTS 
  ? process.env.VUE_APP_ENDPOINTS !== 'production'
  : process.env.NODE_ENV === 'development';

export const CognitoConfig = {
  Auth: {
    region: 'us-east-1',
    userPoolId: useDevEndpoints
      ? 'us-east-1_Xz9dktnrO'      // v3-dev user pool (eyejack-api-v3-dev trusts this)
      : 'us-east-1_XPmiYIn8g',     // prod user pool
    userPoolWebClientId: useDevEndpoints
      ? '252s65e5micbldt90pepjpobu8'   // EyeJack-UserPoolClient-v3-dev
      : '4d0adt7dq74darboj9ctpgbni',   // prod web client
    identityPoolId: useDevEndpoints
      ? 'us-east-1:30283adb-bd56-4936-9578-3463c5786d74'
      : 'us-east-1:2b099346-356a-47ff-bda5-0507b6014798'
  }
};
